import http from "@/config/httpSend";
import { Promise } from "q";

const fetchAction = {
  namespaced: true,
  state: {
    isLoading: true,
    fetch_list_data: [],
    fetch_view_data: {},
    fetch_list_info_data: {},
    fetch_search_category_data: [],
  },
  getters: {
    GE_IS_LOADING: (state) => {
      return state.isLoading;
    },
    GE_PUT_FETCH_LIST_DATA: (state) => {
      return state.fetch_list_data;
    },
    GE_PUT_FETCH_LIST_INFO_DATA: (state) => {
      return state.fetch_list_info_data;
    },
    GE_PUT_FETCH_VIEW_DATA: (state) => {
      return state.fetch_view_data;
    },
  },
  mutations: {
    MU_IS_LOADING: (state, payload) => {
      state.isLoading = payload;
    },
    MU_PUT_FETCH_LIST: (state, payload) => {
      state.fetch_list_data = payload.data[payload.array_name];
      state.fetch_list_info_data.total_count = payload.data.total_count;
      state.fetch_list_info_data.total_page = payload.data.total_page;
      state.fetch_list_info_data.now_page = payload.data.page;
    },
  },
  actions: {
    AC_PUT_FETCH_DATA: ({ commit }, payload) => {
      return new Promise((resolve) => {
        http
          .put("./RESTful/", { data: payload })
          .then((res) => {
            if (res.data !== null) {
              commit(
                "fetchAction/MU_PUT_FETCH_LIST",
                {
                  data: res.data,
                  more: payload.more,
                  array_name: payload.array_name,
                  select_category: payload.item_class_seq,
                },
                { root: true }
              );
              resolve({ more: true, data: res.data });
            } else {
              resolve({ more: false, data: res.data });
            }
          })
          .catch((error) => {
            console.log("FETCH ERROR: ", error);
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              console.log(error.request);
              alert("응답이 없습니다. 잠시 후  다시 시도해주세요.");
            } else {
              console.log("Error", error.message);
              alert("에러가 발생했습니다. 잠시 후  다시 시도해주세요.");
            }
            console.log(error.config);
          });
      });
    },
  },
};

export default fetchAction;
